import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import './LegalPage.css';

const CONTACT_EMAIL = 'flashagency1@outlook.com';
const CONTACT_PHONE = '+852 52134313';

function PrivacyPolicy() {
  const { t } = useI18n();

  return (
    <div className="legal-page">
      <h1 className="legal-page__title">{t('legal.privacy.title')}</h1>
      <p className="legal-page__subtitle">{t('legal.privacy.subtitle')}</p>

      <section className="legal-page__section">
        <h2>{t('legal.privacy.collectTitle')}</h2>
        <p>{t('legal.privacy.collectText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.privacy.usageTitle')}</h2>
        <ul>
          <li>{t('legal.privacy.usageItem1')}</li>
          <li>{t('legal.privacy.usageItem2')}</li>
          <li>{t('legal.privacy.usageItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.privacy.protectTitle')}</h2>
        <p>{t('legal.privacy.protectText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.privacy.rightsTitle')}</h2>
        <p>{t('legal.privacy.rightsText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.privacy.cookiesTitle')}</h2>
        <p>{t('legal.privacy.cookiesText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.privacy.thirdPartyTitle')}</h2>
        <ul>
          <li>{t('legal.privacy.thirdPartyItem1')}</li>
          <li>{t('legal.privacy.thirdPartyItem2')}</li>
          <li>{t('legal.privacy.thirdPartyItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section legal-page__contact">
        <h2>{t('legal.contact.title')}</h2>
        <p>{t('footer.title')}</p>
        <p>{t('footer.companyName')}</p>
        <p>{t('footer.address')}</p>
        <p>
          {t('footer.emailLabel')}: {CONTACT_EMAIL}
        </p>
        <p>
          {t('footer.phoneLabel')}: {CONTACT_PHONE}
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
